module.exports = __webpack_public_path__ + "static/media/galerija_2022_0022.fbada1a1.jpg";